import React from 'react';
import News from '../../models/news.model';
import {Link} from 'react-router-dom';
import { lang } from '../../config/app.config';

interface noticeCardProps{
  notice:News
}

const NoticeCard:React.FC<noticeCardProps> = props =>{
  const {notice} = props;

  return(
    <div className="notice-card">
      {/* <Link to={'/'+lang+"/notice/"+notice.slug}> */}
      <a href={notice.value} target="_blank">
        {notice?.name ?? notice?.title}
        </a>
      {/* </Link> */}
    </div>
  )
}


export default NoticeCard;